import { type Provider, makeDhProvider } from '@glovo/multimedia'
import { makePartnersProvider } from './partners-provider'
import { makeStaticProvider } from './static-provider'
import { getConfig } from '@/tools/config'

export const getProviders = (): Provider[] => {
  const { imageServiceCdn, appUrl } = getConfig()

  const dhProvider = makeDhProvider({ url: imageServiceCdn })
  const partnersProvider = makePartnersProvider({ url: appUrl })
  const staticProvider = makeStaticProvider({ url: appUrl })

  // Providers must be in a specific order. This is important to determine which provider will handle the requested asset.
  return [staticProvider, dhProvider, partnersProvider]
}
